export const brandNames = {
	'AA': 'The AA',
	'ALLIANZ': 'Allianz',
	'BOI': 'Bank of Ireland',
	'CORNMARKET': 'Cornmarket',
	'DEMO': 'this demo environment',
	'FBD': 'FBD'
};

export function getCompanyName(agent) {
	return brandNames[agent] || agent;
}
